import { ChainId, WBNB } from '@pancakeswap/sdk'
import { USDC_DOGE } from './common'

export const dogeTokens = {
  wdoge: WBNB[ChainId.DOGE],
  usdc: USDC_DOGE,
}
